import { getParam } from './urls';

// User entry point constants matching the backend Sourceable enum
export const USER_ENTRY_POINTS = {
  BECOME_VIP_MODAL: 1 as const,
  LEFT_REVIEW: 8 as const,
  ONLINE_ORDERING_CATERING: 5 as const,
  ONLINE_ORDERING_DINE_IN: 6 as const,
  ONLINE_ORDERING_STANDARD: 4 as const,
  POPPED_A_DISH: 9 as const,
  QR_CODE: 3 as const,
  WAITLIST: 0 as const,
} as const;

type AppContext = {
  isCatering?: boolean;
  isOrderingEvent?: boolean;
};

const getOnlineOrderingEntryPoint = (isDineIn: boolean, isCatering: boolean): number => {
  if (isDineIn) {
    return USER_ENTRY_POINTS.ONLINE_ORDERING_DINE_IN;
  }
  if (isCatering) {
    return USER_ENTRY_POINTS.ONLINE_ORDERING_CATERING;
  }
  return USER_ENTRY_POINTS.ONLINE_ORDERING_STANDARD;
};

export const getUserEntryPointFromContext = (appContext?: AppContext): number => getOnlineOrderingEntryPoint(
  false,
  !!appContext?.isCatering,
);

export const getUserEntryPointFromPathname = (pathname: string): number => {
  const lowerPathname = pathname.toLowerCase();
  const isCatering = lowerPathname.includes('/catering');
  const isDineIn = lowerPathname.includes('/dine-in');

  return getOnlineOrderingEntryPoint(isDineIn, isCatering);
};

export const getUserEntryPointFromParam = (isReviewPath?: boolean, isPopPath?: boolean): number | null => {
  if (isReviewPath) {
    return USER_ENTRY_POINTS.LEFT_REVIEW;
  }

  if (isPopPath) {
    return USER_ENTRY_POINTS.POPPED_A_DISH;
  }

  const origin = getParam('origin');

  if (origin === 'qr_code') {
    return USER_ENTRY_POINTS.QR_CODE;
  } else if (origin === 'waitlist') {
    return USER_ENTRY_POINTS.WAITLIST;
  }

  return USER_ENTRY_POINTS.BECOME_VIP_MODAL;
};
